/* Order gate, cart side.

   The product page will not offer Add to cart for a part with no shipping
   weight (snippets/fx-order-gate.liquid). This is the second line: if such a
   part reaches the cart anyway (an old cart, a direct link, a card), checkout
   is held and the notice says which part and how to order it instead. The
   cart page does the same in Liquid (main-cart-footer.liquid), and the app's
   checkout validation is the third line.

   It also puts one line above checkout for dealer accounts pointing at the
   dealer trade terms. window.fxDealer is set in fx-extra.liquid from the
   customer's tags.

   Reads /cart.js only. It re-checks after any request to /cart/, which is
   how both the drawer and Dawn's cart page change the cart. No rAF: the
   automation tab never paints, so everything runs on timers. */
(function () {
  'use strict';

  var MAIL = 'parts@futuratrailers.com';
  var busy = false;
  var again = false;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function holdBox(items) {
    var box = document.createElement('div');
    box.className = 'fx-hold';
    box.setAttribute('data-fx-hold', '');
    box.setAttribute('role', 'status');
    var list = items.map(function (i) {
      return '<li>' + esc(i.product_title) + (i.sku ? ' (' + esc(i.sku) + ')' : '') + '</li>';
    }).join('');
    var subject = encodeURIComponent('Part request: ' + items.map(function (i) {
      return i.product_title + (i.sku ? ' (' + i.sku + ')' : '');
    }).join(', '));
    box.innerHTML =
      '<p class="fx-hold__eyebrow">Checkout on hold</p>' +
      '<p>' + (items.length === 1 ? 'This part' : 'These parts') +
      ' cannot be ordered online yet:</p><ul>' + list + '</ul>' +
      '<p>Remove ' + (items.length === 1 ? 'it' : 'them') + ' to check out, or contact <a href="mailto:' + MAIL +
      '?subject=' + subject + '">' + MAIL + '</a> to order.</p>';
    return box;
  }

  function dealerNote() {
    var p = document.createElement('p');
    p.className = 'fx-dealer-note';
    p.setAttribute('data-fx-dealer-note', '');
    p.innerHTML = 'Dealer order. Our <a href="/pages/dealer-terms">dealer trade terms</a> apply.';
    return p;
  }

  function anchorFor(btn) {
    // The drawer's button sits in a form; the cart page's in .cart__ctas.
    return btn.closest('form') || btn.closest('.cart__ctas') || btn.parentNode;
  }

  function apply(held) {
    var btns = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    [].forEach.call(btns, function (btn) {
      var anchor = anchorFor(btn);
      if (!anchor || !anchor.parentNode) return;
      var parent = anchor.parentNode;

      var box = parent.querySelector(':scope > [data-fx-hold]');
      if (held.length) {
        var key = held.map(function (i) { return i.key; }).join('|');
        if (!box || box.getAttribute('data-fx-key') !== key) {
          if (box) box.remove();
          box = holdBox(held);
          box.setAttribute('data-fx-key', key);
          parent.insertBefore(box, anchor);
        }
        if (!btn.disabled) btn.disabled = true;
        if (!btn.hasAttribute('data-fx-held')) btn.setAttribute('data-fx-held', '');
      } else {
        if (box) box.remove();
        if (btn.hasAttribute('data-fx-held')) {
          btn.removeAttribute('data-fx-held');
          btn.disabled = false;
        }
      }

      if (window.fxDealer && !parent.querySelector(':scope > [data-fx-dealer-note]')) {
        parent.insertBefore(dealerNote(), anchor);
      }
    });
  }

  function check() {
    if (busy) { again = true; return; }
    busy = true;
    rawFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var held = cart.items.filter(function (i) {
          return i.requires_shipping !== false && !i.gift_card && Number(i.grams) === 0;
        });
        apply(held);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(check, 50); }
      });
  }

  var rawFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(check, 120); }, function () {});
    }
    return p;
  };

  function liftSheet() {
    var sheet = document.getElementById('fxGateSheet');
    var shell = sheet && sheet.closest('.fx-gate__shell');
    if (shell && shell.parentNode !== document.body) document.body.appendChild(shell);
  }

  function boot() {
    liftSheet();
    check();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-fx-cart-open]')) setTimeout(check, 200);
    });
    window.addEventListener('pageshow', check);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
